<template>
  <div
    :style="{ position: 'relative', overflow: 'hidden', height: '400px', backgroundColor: popupBackgroundColorValue, backgroundImage: popupBackgroundImage ? `url(${popupBackgroundImage})` : '', backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }">
    <!-- Loader qui masque le contenu pendant le chargement -->
    <div v-if="isLoading" class="loader-container">
      <div class="loader">
        <div class="spinner-container">
          <div class="spinner-dot"></div>
          <div class="spinner-dot"></div>
          <div class="spinner-dot"></div>
        </div>
        <p class="loader-text">Chargement des ressources...</p>
      </div>
    </div>

    <div v-if="!isLoading">

      <div v-for="(block, index) in blocks1" :key="index"
        :style="{ top: block.top + 'px', left: block.left + 'px' }" class="block">


        <div class="media-container"
          :style="{ width: `${block.width}px`, height: `${block.height}px`, position: 'relative' }">
          <transition appear :enter-active-class="block.animation">
            <div v-show="block.animation || block.animation2" :key="index"
              :class="block.animation2 ? block.animation2 : ''">
              <q-icon v-if="block.associatedResources && block.style" class="associated-resources-icon"
                name="new_releases" color="orange"></q-icon>
              <img v-if="block.animation != 'squareImg' && isImage(block.name)" :src="block.imgSrc" alt="Block Image"
                class="img" :style="getStyle(block)" @click="() => { showStyleComponenent(block, index) }" />
              <video v-else-if="isVideo(block.name)" :src="block.imgSrc" :style="getRotationStyleVideo(block)" controls
                class="video-container"></video>
              <audio v-else-if="isAudio(block.name)" :src="block.imgSrc" controls></audio>
            </div>
          </transition>
        </div>

        <!-- Ressources associées positionnées relativement à ce block -->
        <div v-if="getAssociatedImagesForBlock(index).length > 0" class="associated-row">

          <div v-for="(media, mediaIndex) in getAssociatedImagesForBlock(index)" :key="media.src"
            class="associated-thumbnail slide-in" :style="{
              animationDelay: (mediaIndex * 0.1) + 's'
            }">
            <!-- Conteneur de la miniature -->
            <div class="thumbnail-wrapper">
              <!-- Pour les vidéos -->
              <video v-if="isVideo(media.name)" class="thumbnail-media">
                <source :src="media.src" type="video/mp4">
              </video>
              <!-- Pour les PDF -->
              <div v-else-if="isPdf(media.name)" class="thumbnail-media pdf-thumbnail">
                <q-icon name="picture_as_pdf" size="24px" color="red" />
              </div>
              <!-- Pour les audios -->
              <div v-else-if="isAudio(media.name)" class="thumbnail-media audio-thumbnail">
                <q-icon name="audiotrack" size="24px" color="blue" />
              </div>
              <!-- Pour les images -->
              <img v-else :src="media.src" :alt="'Associated image'" class="thumbnail-media" />
              <!-- Overlay avec icône de type -->

            </div>
          </div>
        </div>
      </div>
      <div v-for="(block2, index) in filteredBlocks2" :key="index + 100"
        class="block cartel animate__animated animate__zoomIn"
        :style="{ top: block2.top + 'px', left: block2.left + 'px' }">
        {{ block2.text }}
      </div>

      <!-- Textes personnalisés -->
      <div v-for="(textBlock, index) in textBlocks" :key="'text-' + index" class="text-block"
        :style="getTextBlockStyle(textBlock)">
        <div v-html="textBlock.content"></div>
      </div>

      <div v-if="negatifSlider" class="styleElements">
        <NegatifSlider :blockDatas="blockSliderDatas" @closeSlider="closeSlider()" style='transform: scale(0.3);' />
      </div>
      <div v-if="comicOverlay">
        <ComicsOverlay :block="comicsDatas" />
      </div>
      <div>
        <Carousel3D v-if="carousel3D" :blockDatas="blockCarouselDatas" @closeCarousel3D="closeCarousel3D"
          style='transform: scale(0.3);' />
      </div>
      <div>
        <FlipBook v-if="flipBook" :blockDatas="blockSliderDatas" @closeFlipBook="closeFlipBook"
          style='transform: scale(0.3);' />
      </div>
      <div>
        <Diaporama v-if="diaporama" :blockDatas="blockDiaporamaDatas" @closeDiaporama="closeDiaporama"
          style='transform: scale(0.3);' />
      </div>
      <div>
        <Mosaique v-if="mosaique" :blockDatas="blockMosaiqueDatas" @closeMosaique="closeMosaique"
          style='transform: scale(0.3);' />
      </div>
      <div>
        <Pellicule v-if="pellicule" :blockDatas="blockPelliculeDatas" @closePellicule="closePellicule"
          style='transform: scale(0.3);' />
      </div>
      <div>
        <CoverflowCarousel v-if="coverflow" :blockDatas="blockCoverflowDatas" @closeCoverflow="closeCoverflow"
          style='transform: scale(0.3);' />
      </div>
      <div>
        <AvantApres v-if="avantApres" :blockDatas="blockAvantApresDatas" @closeAvantApres="closeAvantApres"
          style='transform: scale(0.3);' />
      </div>
      <div>
        <SquareImg v-if="squareImg" :blockDatas="squareImgData"
          @click="() => { showStyleComponenent(squareImgData, index) }" />
      </div>
      <div>
        <MusicNotes v-if="musicNotes" />
      </div>
      <div>
        <Scroll v-if="scroll" :blockScrollDatas="blockScrollDatas" @closeScroll="closeScroll"
          style='transform: scale(0.3);' />
      </div>
      <div>
        <VideoComponent v-if="video" :blockVideoDatas="blockVideoDatas" @closeVideo="closeVideo"
          style='transform: scale(0.3);' />
      </div>
      <div>
        <ImageAudio v-if="imageAudio" :blockImageAudioDatas="blockImageAudioDatas" @closeImageAudio="closeImageAudio"
          style='transform: scale(0.3);' />
      </div>
      <div>
        <DocxViewer v-if="docxViewer" :docxResource="blockDocxData" @closeDocxViewer="closeDocxViewer"
          @closeAllDialogs="closeAllDialogs" style='transform: scale(0.3);' />
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted, watch, computed, provide } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import NegatifSlider from "../components/NegatifSlider.vue";
import ComicsOverlay from "../components/ComicsOverlay.vue";
import Carousel3D from "../components/Carousel3D.vue";
import FlipBook from "../components/FlipBook.vue";
import SquareImg from "../components/SquareImg.vue";
import MusicNotes from "../components/MusicNotes.vue";
import Scroll from "../components/Scroll.vue";
import VideoComponent from "../components/Video.vue";
import ImageAudio from "../components/ImageAudio.vue";
import DocxViewer from "../components/DocxViewer.vue";
import Diaporama from "../components/Diaporama.vue";
import Mosaique from "../components/Mosaique.vue";
import Pellicule from "../components/Pellicule.vue";
import CoverflowCarousel from "../components/CoverflowCarousel.vue";
import AvantApres from "../components/AvantApres.vue";

export default {
  props: {
    selectedPointId: {
      type: Number
    },
    selectedResource: {
      type: Object
    }
  },
  components: {
    NegatifSlider,
    ComicsOverlay,
    Carousel3D,
    FlipBook,
    SquareImg,
    MusicNotes,
    Scroll,
    VideoComponent,
    ImageAudio,
    DocxViewer,
    Diaporama,
    Mosaique,
    Pellicule,
    CoverflowCarousel,
    AvantApres
  },
  setup(props) {
    const store = useStore();
    // Fond configurable de l'overlay (mêmes règles que template_6) : les composants
    // d'overlay l'injectent via useOverlayBg().
    let overlayBg = ref({ color: null, imageSrc: null });
    provide('overlayBg', overlayBg);
    let exhibitId = ref();
    let currentPointId = ref();
    let popup = ref(false);
    let blocks1 = ref([])
    let blocks2 = ref([]);
    let blocksDatas = ref();
    let animations = ref();
    const filteredBlocks2 = computed(() => blocks2.value.filter(block => block.text !== 'undefined' && block.text !== null && block.text !== ""));
    let negatifSlider = ref(false);
    let blockSliderDatas = ref();
    let comicOverlay = ref();
    let flipBook = ref(false);
    let squareImg = ref(false);
    let showBlock = ref(true);
    let musicNotes = ref(false);
    let comicsDatas = ref();
    let blockScrollDatas = ref();
    let blockCarouselDatas = ref();
    let blockImageAudioDatas = ref();
    let carousel3D = ref(false)
    let squareImgData = ref();
    let video = ref(false);
    let scroll = ref(false)
    let blockVideoDatas = ref();
    let docxViewer = ref(false);
    let diaporama = ref(false);
    let blockDiaporamaDatas = ref();
    let mosaique = ref(false);
    let blockMosaiqueDatas = ref();
    let pellicule = ref(false);
    let blockPelliculeDatas = ref();
    let coverflow = ref(false);
    let blockCoverflowDatas = ref();
    let avantApres = ref(false);
    let blockAvantApresDatas = ref();
    let isLoading = ref(false);
    let loadingTimeout = null; // Timer pour debounce du loader
    let textBlocks = ref([]);
    let associatedImagesByBlock = ref({});
    //let previewDialog = ref(false);
    //let previewResource = ref(null);
    let isLoadingThumbnails = ref(false);
    let blockDocxData = ref(null);
    let imageAudio = ref(null);
    let popupBackgroundImage = ref(null);
    let popupBackgroundColorValue = ref(null);
    let titleColor = ref(null);
    let titleSize = ref(null);
    const start = async () => {
      exhibitId.value = store.state.exhibitId;
      if (exhibitId.value == undefined) {
        exhibitId.value = props.exhibitIdBis;
      }
      //await getMainResource();
      //await getResourcesFromPoints();
      await getAnimations();
      showPopup(props.selectedPointId)
      fetchPointColors();
      loadPopupBackgroundImage();
    };




    const getAnimations = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/resource_animation/${exhibitId.value}`;
        let response = await axios.get(url);
        animations.value = response.data;
      } catch (error) {
        console.log(error);
      }
    }

    const showAnimations = async () => {
      let newBlocks1 = [...blocks1.value]; // Création d'une nouvelle instance du tableau
      for (let block of newBlocks1) {
        if (Array.isArray(animations.value) && animations.value.some(animation => animation.resource_id == block.resourceId && animation.point_id == currentPointId.value)) {
          let animation = animations.value.find(animation => animation.resource_id == block.resourceId && animation.point_id == currentPointId.value)
          let animationString;
          if (animation.animation === "spin" || animation.animation === "slide" || animation.animation === "pulse" || animation.animation === "swingRotate" || animation.animation === "verticalBounce") {
            block['animation2'] = animation.animation
          } else if (animation.animation == "squareImg") {
            block['animation'] = "squareImg";
          } else if (animation.animation == "musicNote") {
            musicNotes.value = true
            block['animation'] = "musicNote"
          } else {
            animationString = 'animate__animated animate__' + animation.animation + " animate__slower";
            block['animation'] = animationString;
          }
        } else {
          block['animation'] = 'animate__animated animate__zoomIn';
        }
      }
      blocks1.value = newBlocks1; // Assignation du nouveau tableau à blocks1.value
    }

    const getResourcesFromPoints = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/resourcesFromPointWithAssociations/${currentPointId.value}`;
        let response = await axios.get(url);
        blocksDatas.value = response.data;
        await loadSavedTexts();
      } catch (error) {
        console.log(error);
      }
    }

    //Recupération de la couleur du popup
    const fetchPointColors = async () => {
      try {
        const url = `${process.env.VUE_APP_BASEURL}/intermediateColor/${currentPointId.value}`;
        const response = await axios.get(url);
        if (response.data && response.data[0]) {
          popupBackgroundColorValue.value = response.data[0].background_color;
          titleColor.value = response.data[0].text_color;
          titleSize.value = response.data[0].text_size;
        } else {
          // Réinitialiser si aucune donnée n'est trouvée
          popupBackgroundColorValue.value = null;
          titleColor.value = null;
          titleSize.value = null;
        }
      } catch (error) {
        console.log('Erreur lors de la récupération des couleurs du point:', error);
        // Réinitialiser en cas d'erreur
        popupBackgroundColorValue.value = null;
        titleColor.value = null;
        titleSize.value = null;
      }
    }

    // Fonction pour charger l'image de fond du popup
    const loadPopupBackgroundImage = async () => {
      try {
        console.log('🔍 Chargement image de fond pour point:', currentPointId.value);

        // ⚠️ IMPORTANT: Réinitialiser l'image précédente
        popupBackgroundImage.value = null;
        console.log('🧹 Image précédente effacée');

        const url = `${process.env.VUE_APP_BASEURL}/pointBackgroundImage/point/${currentPointId.value}`;
        const response = await axios.get(url);
        console.log('📡 Réponse API pointBackgroundImage:', response.data);

        // Extraire l'ID de la ressource à partir de la réponse
        const resourceId = response.data?.resource_id ||
          response.data?.background_image_id ||
          (response.data[0] ? response.data[0].resource_id : null);

        console.log('🔑 ResourceId trouvé:', resourceId);

        if (resourceId) {
          // Chercher la ressource correspondante
          const resourceUrl = `${process.env.VUE_APP_BASEURL}/resourceData/${resourceId}`;
          const resourceResponse = await axios.get(resourceUrl);
          console.log('📡 Réponse API resourceData:', resourceResponse.data);

          if (resourceResponse.data && resourceResponse.data.length > 0) {
            const resource = resourceResponse.data[0];
            console.log('📄 Resource trouvée:', resource);

            // Charger l'image
            const imageUrl = `${process.env.VUE_APP_BASEURL}/s3Resource/${resource.name}`;
            const imageResponse = await axios.get(imageUrl);
            console.log('🖼️ Image chargée, URL length:', imageResponse.data?.length);

            // Appliquer l'image de fond
            popupBackgroundImage.value = imageResponse.data;
            console.log('✅ popupBackgroundImage définie:', !!popupBackgroundImage.value);
          }
        } else {
          console.log('❌ Aucun resourceId trouvé');
        }
      } catch (error) {
        console.error('❌ Erreur lors du chargement de l\'image de fond du popup:', error);
      }
    };

    // Charger les textes enregistrés pour ce point
    const loadSavedTexts = async () => {
      try {
        // Utiliser l'endpoint existant pour récupérer les textes par point_id
        const url = `${process.env.VUE_APP_BASEURL}/custom-texts/point/${currentPointId.value}`;
        const response = await axios.get(url);

        if (response.data && response.data.length) {
          // Transformer les données reçues au format utilisé par le composant
          textBlocks.value = response.data.map(text => ({
            id: text.id,
            content: text.content,
            top: text.position_top,
            left: text.position_left,
            width: text.width,
            height: text.height,
            fontFamily: text.font_family,
            fontSize: text.font_size,
            color: text.color,
            backgroundColor: text.background_color,
            borderWidth: text.border_width,
            borderStyle: text.border_style,
            borderColor: text.border_color,
            borderRadius: text.border_radius,
            boxShadow: text.box_shadow
          }));
        }
      } catch (error) {
        console.log(error);
      }
    };

    const getTextBlockStyle = (block) => {
      // Même repère et même facteur que les blocs images (canvas admin 1400 de large)
      const SCALE = 600 / 1400; // ≈ 0.4286

      // Projection linéaire proportionnelle, identique sur X et Y
      const calculatedTop = block.top * SCALE;
      const calculatedLeft = block.left * SCALE;

      // Mise à l'échelle visuelle identique aux autres blocks
      const toNumber = (v, d = 0) => (typeof v === 'number' ? v : (parseFloat(v) || d));
      const scaledWidth = block.width != null ? Math.round(toNumber(block.width) * SCALE) : null;
      const scaledHeight = block.height != null ? Math.round(toNumber(block.height) * SCALE) : null;
      const scaledFontSize = Math.max(1, toNumber(block.fontSize, 16) * SCALE);
      const scaledBorderWidth = Math.max(0, toNumber(block.borderWidth, 0) * SCALE);
      const scaledBorderRadius = Math.max(0, toNumber(block.borderRadius, 0) * SCALE);
      const scaledPadding = Math.max(0, toNumber(block.padding, 10) * SCALE);

      return {
        position: 'absolute',
        top: calculatedTop + 'px',
        left: calculatedLeft + 'px',
        width: scaledWidth ? scaledWidth + 'px' : 'auto',
        height: scaledHeight ? scaledHeight + 'px' : 'auto',
        fontFamily: block.fontFamily || 'Arial',
        fontSize: scaledFontSize + 'px',
        lineHeight: 1.25,
        color: block.color || '#000000',
        backgroundColor: block.backgroundColor || 'transparent',
        padding: scaledPadding + 'px',
        borderWidth: scaledBorderWidth + 'px',
        borderStyle: block.borderStyle || 'solid',
        borderColor: block.borderColor || 'transparent',
        borderRadius: scaledBorderRadius + 'px',
        boxSizing: 'border-box',
        whiteSpace: 'pre-wrap',
        boxShadow: block.boxShadow || 'none'
      };
    };

    const showBlocks = async () => {
      try {
        blocks1.value.splice(0);
        blocks2.value.length = 0;

        // Repère admin (Intermediate.vue) : canvas 1400 x 800, positions stockées brutes.
        // On projette proportionnellement dans la boîte de preview (600px de large),
        // avec le MÊME facteur sur les deux axes pour conserver la géométrie d'origine.
        const ADMIN_CANVAS_WIDTH = 1400;
        const FIXED_CANVAS_WIDTH = 600;
        const SCALE = FIXED_CANVAS_WIDTH / ADMIN_CANVAS_WIDTH; // ≈ 0.4286
        for (var data of blocksDatas.value) {
          let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${data.name}`;
          let response = await axios.get(url);
          const base64data = response.data;
          let url2 = `${process.env.VUE_APP_BASEURL}/position/${data.resource_id}`;
          let response2 = await axios.get(url2);
          if (response2.data.length > 1) {
            response2.data = response2.data.filter(element => element.point_id == store.state.pointSelected.point_id)
          }
          let url3 = `${process.env.VUE_APP_BASEURL}/style/${data.resource_id}/${data.point_id}`;
          let response3 = await axios.get(url3);
          let style = response3.data[0] ? response3.data[0].style : null;
          var obj = {};
          obj.bg_color = response3.data[0] ? response3.data[0].bg_color : null;
          obj.bg_image_id = response3.data[0] ? response3.data[0].bg_image_id : null;
          if (response2.data[0]) {
            // Projection linéaire proportionnelle, identique sur X et Y
            obj.top = response2.data[0].y * SCALE;
            obj.left = response2.data[0].x * SCALE;
            obj.width = response2.data[0].width * SCALE;
            obj.height = response2.data[0].height * SCALE;
            obj.angle = response2.data[0].angle;
            obj.radius = response2.data[0] ? response2.data[0].border_radius : 10;
            obj.borderColor = response2.data[0] ? response2.data[0].border_color : "#ffffff";
            obj.borderWidth = response2.data[0] ? response2.data[0].border_width : 0;
            obj.boxShadow = response2.data[0] ? response2.data[0].shadow : "0px 0px 0px #000000";
            obj.title = data.title;

          } else {
            // Système de grille intelligente pour les ressources sans position
            const currentIndex = blocks1.value.filter(b => !b.hasDefaultPosition).length;
            const gridSize = 110; // Espacement entre ressources
            const cols = 3; // 3 colonnes
            const startTop = 40;
            const startLeft = 20;

            obj.top = startTop + (Math.floor(currentIndex / cols) * gridSize);
            obj.left = startLeft + ((currentIndex % cols) * gridSize);
            obj.width = 100;
            obj.height = 100;
            obj.angle = 0;
            obj.hasDefaultPosition = true; // Marqueur pour identifier les positions par défaut
          }
          obj.resourceId = data.resource_id;
          obj.name = data.name;
          obj.imgSrc = base64data;
          obj.associatedResources = data.associatedResources;
          obj.style = style;
          obj.title = data.title;
          blocks1.value.push(obj);
        }
        for (var data2 of blocksDatas.value) {
          let url3 = `${process.env.VUE_APP_BASEURL}/position/${data2.resource_id}`;
          let response3 = await axios.get(url3);

          if (response3.data.length > 1) {
            response3.data = response3.data.filter(element => element.point_id == store.state.pointSelected.point_id)
          }
          var obj2 = {};
          if (response3.data[0]) {
            obj2.top = response3.data[0].description_y * SCALE;
            obj2.left = response3.data[0].description_x * SCALE;
            obj2.text = response3.data[0].description;
          } else {
            // Position cohérente avec la grille des ressources
            const currentIndex = blocks2.value.filter(b => !b.hasDefaultPosition).length;
            const gridSize = 110;
            const cols = 3;
            const startTop = 200; // Décalé vers le bas par rapport aux images
            const startLeft = 20;

            obj2.top = startTop + (Math.floor(currentIndex / cols) * gridSize);
            obj2.left = startLeft + ((currentIndex % cols) * gridSize);
            obj2.text = "";
            obj2.hasDefaultPosition = true;
          }
          obj2.resourceId = data2.resource_id;
          if (obj2.text != null && obj2.text != undefined && obj2.text != "") {
            blocks2.value.push(obj2);
          }
        }
        showAnimations();

        blocks1.value.map(block => {
          showBlockStyle(block)

        })
      } catch (error) {
        console.log(error);
      }
    };



    const showPopup = async (pointId) => {
      currentPointId.value = pointId;
      popup.value = true;
      isLoading.value = true;

      // Important: recharger les animations à chaque ouverture/rafraîchissement
      await getAnimations();

      await getResourcesFromPoints();
      await showBlocks();

      // Désactiver le loader avec debounce pour la cohérence
      if (loadingTimeout) {
        clearTimeout(loadingTimeout);
      }
      loadingTimeout = setTimeout(() => {
        isLoading.value = false;
        loadingTimeout = null;
      }, 500);
    }

    function isImage(name) {
      const extension = name.split(".").pop().toLowerCase();
      return ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension);
    }

    const loadOverlayBgImage = async (id) => {
      if (!id) return;
      try {
        const r1 = await axios.get(`${process.env.VUE_APP_BASEURL}/resourceData/${id}`);
        const name = r1.data && r1.data[0] && r1.data[0].name;
        if (!name) return;
        const r2 = await axios.get(`${process.env.VUE_APP_BASEURL}/s3Resource/${name}`);
        overlayBg.value = { ...overlayBg.value, imageSrc: r2.data };
      } catch (e) { console.log('loadOverlayBgImage', e); }
    };

    const showStyleComponenent = (block, index) => {
      console.log("showStyleComponenent", block)
      overlayBg.value = { color: block.bg_color || null, imageSrc: null };
      if (block.bg_image_id) loadOverlayBgImage(block.bg_image_id);
      if (block.associatedResources && block.style == "negatifSlider") {
        negatifSlider.value = true;
      }
      if (block.associatedResources && block.style == "carousel3D") {
        carousel3D.value = true;
        blockCarouselDatas.value = block
      }
      if (block.associatedResources && block.style == "scroll") {
        scroll.value = true;
        blockScrollDatas.value = block
      }
      if (block.associatedResources && block.style == "flipBook") {
        flipBook.value = true;
      }
      if (block.associatedResources && block.style == "video") {
        video.value = true;
        blockVideoDatas.value = block
      }
      if (block.associatedResources && block.style == "imageAudio") {
        imageAudio.value = true;
        blockImageAudioDatas.value = block;
      }
      if (block.style == "docx") {
        blockDocxData.value = block;
        docxViewer.value = true;
      }
      if (block.associatedResources && block.style == "diaporama") {
        diaporama.value = true;
        blockDiaporamaDatas.value = block
      }
      if (block.associatedResources && block.style == "mosaique") {
        mosaique.value = true;
        blockMosaiqueDatas.value = block
      }
      if (block.associatedResources && block.style == "pellicule") {
        pellicule.value = true;
        blockPelliculeDatas.value = block
      }
      if (block.associatedResources && block.style == "coverflow") {
        coverflow.value = true;
        blockCoverflowDatas.value = block
      }
      if (block.associatedResources && block.style == "avantApres") {
        avantApres.value = true;
        blockAvantApresDatas.value = block
      }

      if (block.style == "link") {
        addLinkToBlock(block, index)
      }
      blockSliderDatas.value = block;
    }

    const addLinkToBlock = (block, index) => {
      // Récupération du block
      let blocks = document.querySelectorAll(".block"); // utilisation de querySelectorAll au lieu de getElementsByClassName
      let selectedBlock = blocks[index];

      // Récupérer l'URL depuis le titre
      let matches = block.title.match(/\[(.*?)\]/);
      if (matches) {
        let url = matches[1];

        // Assigner l'URL au bloc et le rendre cliquable
        selectedBlock.style.cursor = "pointer";
        selectedBlock.addEventListener("click", () => {
          window.open(url, "_blank"); // ouvrez le lien dans un nouvel onglet
        });
      }
    }

    const getStyle = (block) => {
      return {
        width: `${block.width}px`,
        height: `${block.height}px`,
        transform: `rotate(${block.angle}deg)`,
        borderRadius: block.radius + 'px',
        border: `solid ${block.borderWidth}px ${block.borderColor}`,
        boxShadow: block.boxShadow,
        cursor: block.style == "link" ? 'pointer' : 'default'
      };
    }

    const closeAll = () => {
      comicOverlay.value = false;
      squareImg.value = false;
      musicNotes = false;
      blocks1.value.splice(0);
      blocks2.value = [];
    }

    const closeObjects = () => {
      closeCarousel3D();
      closeScroll();
      closeSlider();
      closeFlipBook();
      closeVideo();
    }

    const closeCarousel3D = () => {
      carousel3D.value = false;
    }

    const closeImageAudio = () => {
      imageAudio.value = false;
    }

    const closeSlider = () => {
      negatifSlider.value = false;
    }

    const closeScroll = () => {
      scroll.value = false
    }

    const closeFlipBook = () => {
      flipBook.value = false;
    }

    const closeVideo = () => {
      video.value = false;
      blockVideoDatas.value = {};
    }

    const closeDiaporama = () => {
      diaporama.value = false;
    }

    const closeMosaique = () => {
      mosaique.value = false;
    }

    const closePellicule = () => {
      pellicule.value = false;
    }

    const closeCoverflow = () => {
      coverflow.value = false;
    }

    const closeAvantApres = () => {
      avantApres.value = false;
    }

    const isPdf = (filename) => {
      return filename.toLowerCase().endsWith('.pdf');
    }

    function isVideo(name) {
      const extension = name.split(".").pop().toLowerCase();
      return ["mp4", "webm", "avi", "mov", "mkv"].includes(extension);
    }

    function isAudio(name) {
      const extension = name.split(".").pop().toLowerCase();
      return ["mp3", "wav", "ogg", "m4a"].includes(extension);
    }

    const getRotationStyleVideo = (block) => {
      return {
        transform: `rotate(${block.angle}deg)`,
        borderRadius: block.radius + 'px',
        border: `solid ${block.borderWidth}px ${block.borderColor}`,
        objectFit: 'contain',
        width: `${block.width}px`,
        height: `${block.height}px`,
        boxShadow: block.boxShadow

      };
    };

    const showBlockStyle = (block) => {
      blockSliderDatas.value = block
      if (block.style == "comics") {
        comicOverlay.value = true
        comicsDatas.value = block;
      }
      if (block.animation == "squareImg") {
        showBlock.value = false;
        squareImg.value = true
        block.top = block.top + 50;
        squareImgData.value = block;
      }

    }

    const getAssociatedImagesForBlock = (blockIndex) => {
      return associatedImagesByBlock.value[blockIndex] || [];
    };

    const displayAssociatedResourcesInRow = async (block, blockIndex = 0) => {
      associatedImagesByBlock.value[blockIndex] = []; // Réinitialiser le tableau pour ce block
      console.log("displayAssociatedResourcesInRow", block, "blockIndex:", blockIndex);
      const resources = block.associatedResources;
      if (!resources || resources.length == 0) return;

      // Activer l'indicateur de chargement des miniatures
      isLoadingThumbnails.value = true;

      // Créer un tableau de promesses pour charger toutes les ressources
      const loadPromises = [];

      for (let i = 0; i < resources.length; i++) {
        const resource = resources[i];

        // Créer une promesse pour chaque ressource
        const loadPromise = new Promise((resolve) => {
          // Fonction pour ajouter l'image au tableau associatedImages
          const addImageToAssociatedImages = (imageData, extension) => {
            if (!associatedImagesByBlock.value[blockIndex]) {
              associatedImagesByBlock.value[blockIndex] = [];
            }
            associatedImagesByBlock.value[blockIndex].push({
              src: imageData,
              name: resource.name,
              extension: extension,
              originalResource: resource // Garder la référence originale
            });
            resolve();
          };

          // Charger la ressource
          axios.get(`${process.env.VUE_APP_BASEURL}/s3Resource/${resource.name}`)
            .then(response => {
              const extension = resource.name.split(".").pop().toLowerCase();
              addImageToAssociatedImages(response.data, extension);
            })
            .catch(error => {
              console.error("Erreur de chargement de ressource:", error);
              resolve();
            });
        });

        loadPromises.push(loadPromise);
      }

      // Attendre que toutes les ressources soient chargées
      await Promise.all(loadPromises);

      // Désactiver l'indicateur de chargement
      isLoadingThumbnails.value = false;
    };

    const closeDocxViewer = () => {
      docxViewer.value = false;
      blockDocxData.value = null;
    };

    const openResource = (media) => {
      // Gestion de l'ouverture d'une ressource associée
      if (media.extension && ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(media.extension)) {
        // Pour les images, ouvrir dans une lightbox ou un viewer
        window.open(media.src, '_blank');
      } else if (media.extension && ['mp4', 'webm', 'avi', 'mov', 'mkv'].includes(media.extension)) {
        // Pour les vidéos, ouvrir le composant video
        video.value = true;
        blockVideoDatas.value = {
          ...media.originalResource,
          imgSrc: media.src,
          name: media.name
        };
      } else if (media.extension && ['pdf'].includes(media.extension)) {
        // Pour les PDF, ouvrir dans un nouvel onglet
        window.open(media.src, '_blank');
      } else if (media.extension && ['mp3', 'wav', 'ogg', 'm4a'].includes(media.extension)) {
        // Pour l'audio, créer un lecteur temporaire
        const audio = new Audio(media.src);
        audio.play();
      }
    };

    watch(() => props.selectedPointId, (newValue) => {
      console.log('selectedPointId changed')
      showPopup(newValue);
    })

    watch(() => props.selectedResource, async (newValue) => {
      // Ne rien faire si la nouvelle valeur est null ou undefined
      if (!newValue) return;

      console.log('selectedResource changed', newValue);

      // Activer le loader
      isLoading.value = true;

      // Fermer les objets ouverts avant de mettre à jour
      closeObjects();

      if (newValue.resource_id || newValue.id) {
        // Recharger les blocs pour s'assurer d'avoir les données les plus récentes
        await showBlocks();

        // Filtrer les blocs pour n'afficher que celui qui est sélectionné
        const resourceId = newValue.resource_id || newValue.id;
        blocks1.value = blocks1.value.filter(b => b.resourceId === resourceId || b.title === newValue.title);
        blocks2.value = blocks2.value.filter(b => b.resourceId === resourceId);

        console.log('Filtered blocks2:', blocks2.value);

        // Vérifier l'animation
        if (blocks1.value.length > 0) {
          if (blocks1.value[0].animation === "squareImg") {
            squareImg.value = true;
          } else {
            squareImg.value = false;
          }

          // Afficher les ressources associées
          await displayAssociatedResourcesInRow(blocks1.value[0]);
        }
      }

      // Désactiver le loader avec debounce pour éviter les clignotements
      if (loadingTimeout) {
        clearTimeout(loadingTimeout);
      }
      loadingTimeout = setTimeout(() => {
        isLoading.value = false;
        loadingTimeout = null;
      }, 2500); // 2.5s pour couvrir toute la séquence reloadComponent
    })

    onMounted(start);
    return {
      exhibitId,
      blocks1,
      blocks2,
      isImage,
      filteredBlocks2,
      comicOverlay,
      squareImg,
      showBlock,
      musicNotes,
      comicsDatas,
      blockCarouselDatas,
      blockScrollDatas,
      video,
      blockVideoDatas,
      carousel3D,
      negatifSlider,
      flipBook,
      scroll,
      blockSliderDatas,
      blocksDatas,
      imageAudio,
      blockImageAudioDatas,
      squareImgData,
      associatedImagesByBlock,
      textBlocks,
      isLoading,
      closeAll,
      closeCarousel3D,
      closeSlider,
      closeScroll,
      closeFlipBook,
      closeVideo,
      showStyleComponenent,
      isPdf,
      isVideo,
      isAudio,
      closeImageAudio,
      getStyle,
      getRotationStyleVideo,
      getTextBlockStyle,
      docxViewer,
      blockDocxData,
      closeDocxViewer,
      diaporama,
      blockDiaporamaDatas,
      closeDiaporama,
      mosaique,
      blockMosaiqueDatas,
      closeMosaique,
      pellicule,
      blockPelliculeDatas,
      closePellicule,
      coverflow,
      blockCoverflowDatas,
      closeCoverflow,
      avantApres,
      blockAvantApresDatas,
      closeAvantApres,
      openResource,
      isLoadingThumbnails,
      getAssociatedImagesForBlock,
      loadPopupBackgroundImage,
      popupBackgroundImage,
      popupBackgroundColorValue,
      fetchPointColors
    }
  }

}
</script>
<style scoped>
.block {
  position: absolute;
}

.cartel {
  background-color: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 30px;
  margin-bottom: 30px;
  font-family: 'Roboto', Arial, sans-serif;
  font-size: 12px;
  line-height: 1.6;
  text-align: justify;
  max-width: 250px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transform: scale(0.5);
}

.img {
  max-width: 100vw;
  border-radius: 10px;
  object-fit: contain;
  display: block;
  border: 2px solid #f0f0f0;
}

/* Styles pour le loader */
.loader-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 150%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(250, 250, 250, 0.98);
  z-index: 9999;
  border-radius: 8px;
  backdrop-filter: blur(4px);
}

.loader {
  background: #ffffff;
  padding: 48px 64px;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e5e5;
}

.spinner-container {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

.spinner-dot {
  width: 12px;
  height: 12px;
  background: #2c2c2c;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}

.spinner-dot:nth-child(1) {
  animation-delay: -0.32s;
}

.spinner-dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: scale(0.8);
    opacity: 0.5;
  }

  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

.loader-text {
  margin: 0;
  color: #4a4a4a;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.3px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.spin {
  animation: spin 6s infinite linear !important;
}

@keyframes slide {

  0%,
  100% {
    transform: translateX(-100%);
  }

  50% {
    transform: translateX(0);
  }
}

.slide {
  animation: slide 3s infinite !important;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

.pulse {
  animation: pulse 1s infinite alternate !important;
}

@keyframes swingRotate {
  0% {
    transform: rotate(-50deg);
  }

  50% {
    transform: rotate(50deg);
  }

  100% {
    transform: rotate(-50deg);
  }
}

.swingRotate {
  animation: swingRotate 2s ease-in-out infinite;
}

@keyframes verticalBounce {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-30px);
    /* Modifiez cette valeur pour ajuster l'amplitude */
  }

  100% {
    transform: translateY(0);
  }
}

.verticalBounce {
  animation: verticalBounce 1s ease-in-out infinite;
}

/* Styles pour les ressources associées */
.associated-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
  padding: 10px 0;
  flex-wrap: wrap;
  max-width: 210px;
  /* Approx 2 items (80px * 2) + gap (15px) + padding */
  margin-left: auto;
  margin-right: auto;
}

.associated-thumbnail {
  transition: all 0.3s ease;
  cursor: pointer;
  flex-shrink: 0;
}

.associated-thumbnail.slide-in {
  animation: slideInFromBottom 0.5s ease-out forwards;
  opacity: 0;
}

@keyframes slideInFromBottom {
  0% {
    transform: translateY(30px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.thumbnail-wrapper {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  background: white;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.thumbnail-wrapper:hover {
  transform: scale(1.1) translateY(-5px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  z-index: 1001;
}

.thumbnail-media {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.pdf-thumbnail,
.audio-thumbnail {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  width: 100%;
  height: 100%;
}

.file-type-overlay {
  position: absolute;
  bottom: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

/* Conteneur avec scroll horizontal si nécessaire */
@media (max-width: 768px) {
  .associated-resources-container {
    overflow-x: auto;
    white-space: nowrap;
    padding: 10px 0;
    -webkit-overflow-scrolling: touch;
  }

  .associated-thumbnail {
    display: inline-block;
  }
}

/* Animation de chargement */
.loading-thumbnail {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}
</style>
